module.exports = __webpack_public_path__ + "img/icon_bms11.2a2a5e41.jpg";